(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  class PromoPopup extends HTMLElement {
    #dialog;
    #timer;
    #closeButtons;

    connectedCallback() {
      this.#dialog = this.querySelector('dialog');
      if (!this.#dialog) return;

      this.#closeButtons = this.querySelectorAll('[data-promo-popup-close]');
      this.#closeButtons.forEach((button) => {
        button.addEventListener('click', this.#close);
      });

      this.#dialog.addEventListener('click', this.#onDialogClick);
      this.#dialog.addEventListener('close', this.#onNativeClose);

      if (this.hasAttribute('data-design-mode')) {
        this.#open();
        return;
      }

      if (this.#isDismissed()) return;

      const delaySeconds = Number(this.dataset.delay || 0);
      const delayMs = Number.isFinite(delaySeconds) ? Math.max(0, delaySeconds) * 1000 : 0;
      this.#timer = window.setTimeout(this.#open, delayMs);
    }

    disconnectedCallback() {
      window.clearTimeout(this.#timer);
      this.#closeButtons?.forEach((button) => {
        button.removeEventListener('click', this.#close);
      });
      this.#dialog?.removeEventListener('click', this.#onDialogClick);
      this.#dialog?.removeEventListener('close', this.#onNativeClose);
    }

    #isDismissed = () => {
      if (this.dataset.remember !== 'true') return false;
      try {
        return window.sessionStorage.getItem(this.dataset.storageKey) === '1';
      } catch {
        return false;
      }
    };

    #rememberDismiss = () => {
      if (this.dataset.remember !== 'true') return;
      try {
        window.sessionStorage.setItem(this.dataset.storageKey, '1');
      } catch {
        /* no-op */
      }
    };

    #open = () => {
      if (!this.#dialog || this.#dialog.open) return;
      this.#dialog.showModal();
    };

    #close = () => {
      if (!this.#dialog || !this.#dialog.open) return;
      this.#rememberDismiss();
      this.#dialog.close();
    };

    #onDialogClick = (event) => {
      if (event.target === this.#dialog) this.#close();
    };

    #onNativeClose = () => {
      this.#rememberDismiss();
    };
  }

  if (!customElements.get('promo-popup')) {
    customElements.define('promo-popup', PromoPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
